/**
 * Payment provider values
 */
export enum PaymentProviderEnum {
	VIVA = 'viva',
	SAFERPAY = 'saferpay',
}
